export default __webpack_public_path__ + "static/media/ModalImage30.f7ef42ce.PNG";